import React, { FunctionComponent } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';
import cn from 'classnames';

import { Button, Modal } from '..';
import { DEFAULT_MODAL_Z_INDEX } from '../../constants';
import { i18n } from '../../helpers/i18n';
import { ModalProps } from '../modal';
import CloseModalButton from '../modal/close-button';
import css from './index.css';

interface ModalConfirmProps extends Pick<ModalProps, 'size'> {
    onClose(): void;
    onConfirm(): void;
    onCancel?(): void;
    scrollContent?: boolean;
    headerText: string;
    cancelButtonText?: string;
    confirmButtonText: string;
    classNames?: {
        modal?: string;
        container?: string;
        header?: string;
        headerText?: string;
        cotent?: string;
        footer?: string;
    };
    scope?: React.RefObject<HTMLElement> | 'inplace';
    testId?: string;
}

/**
 * @deprecated Используем ModalConfirmPure из ./modal-confirm-pure
 */
export const ModalConfirm: FunctionComponent<ModalConfirmProps> = ({
    size,
    onClose,
    onConfirm,
    onCancel,
    classNames,
    headerText,
    cancelButtonText,
    confirmButtonText,
    scrollContent,
    children,
    scope,
    testId,
}) => {
    return (
        <ScopedTheme theme="dark">
            <Modal
                size={size}
                className={cn(css.modal, classNames?.modal)}
                keepMounted
                onClose={onClose}
                visible
                testId={testId}
                zIndex={DEFAULT_MODAL_Z_INDEX}
                scope={scope}
                disableFixedOverlay
            >
                <div className={cn(css.container, classNames?.container)}>
                    <div className={cn(css.header, classNames?.header)}>
                        <div className={cn(css.headerText, classNames?.headerText)}>{headerText}</div>
                        <div className={css.headerButtonContainer}>
                            <CloseModalButton onClose={onClose} ariaLabel={i18n('common', 'close-dialog')} />
                        </div>
                    </div>
                    <div className={cn(css.content, { [css.contentScrollable]: scrollContent }, classNames?.cotent)}>
                        {children}
                    </div>
                    <div className={cn(css.footer, classNames?.footer)}>
                        {cancelButtonText ? (
                            <Button className={css.buttonCancel} view="neutral" size="md" onClick={onCancel || onClose}>
                                {cancelButtonText}
                            </Button>
                        ) : null}
                        <Button
                            className={css.buttonConfirm}
                            view="brand"
                            size="md"
                            onClick={onConfirm}
                            // Переносим фокус с кнопки закрытия на кнопку подтверждения, у которой нет стилизации
                            tabIndex={1}
                        >
                            {confirmButtonText}
                        </Button>
                    </div>
                </div>
            </Modal>
        </ScopedTheme>
    );
};
